import { GALLERY } from "@/data/content";
import { Link } from "react-router-dom";

export default function GallerySection({ full = false }) {
  const items = full ? GALLERY : GALLERY.slice(0, 6);
  return (
    <section data-testid="gallery-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-xl">
            <span className="overline">Gallery</span>
            <h2 className="font-serif text-4xl md:text-5xl text-navy mt-3 leading-[1.05] tracking-tight">
              Moments from the journey
            </h2>
          </div>
          {!full && (
            <Link
              to="/gallery"
              data-testid="gallery-view-all"
              className="text-sm text-navy underline underline-offset-4 decoration-[var(--maqam-gold)]"
            >
              View full gallery →
            </Link>
          )}
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
          {items.map((g, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden rounded-lg group ${
                i % 5 === 0 ? "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto md:h-full" : "aspect-[4/5]"
              }`}
            >
              <img
                src={g.url}
                alt={g.caption}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 p-3 md:p-4 text-white text-xs md:text-sm bg-gradient-to-t from-black/70 to-transparent">
                {g.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
